import React, { useState } from "react"

import { ItemTypes } from "./Constants.js"
import { useDrag, useDrop, DragPreviewImage } from "react-dnd"

import {
  Mark,
  MarkIcon,
} from "../styled-components-openmark"
import styled, { css } from "styled-components"

import { getTextLength, cutTextLimit } from "../jace"

const LinkMark = ({ pageId, groupId, markId, mark }) => {
  return (
    <>
      <Mark>
        <a href={mark.url} target="_blank">
          {mark.thumbnail ? (
            <MarkIcon thumbnail={mark.thumbnail} />
          ) : (
            <MarkIcon bgColor={mark.bgColor} color={mark.color}>
              {mark.title}
            </MarkIcon>
          )}
        </a>
        <div>
          {getTextLength(mark.title) > 20 ? (
            <span>{cutTextLimit(mark.title, 18)}⋯</span>
          ) : (
            mark.title
          )}
        </div>
      </Mark>
    </>
  )
}

export default LinkMark
